export default __webpack_public_path__ + "static/media/avatar_4.07106740.svg";